import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

/** Small rollout label for newly shipped admin controls. */
export function NewFeatureBadge({ className }: { className?: string }) {
    return (
        <Badge
            variant="success"
            className={cn("text-[10px] px-1.5 py-0 h-4 font-semibold uppercase tracking-wide", className)}
        >
            New
        </Badge>
    );
}
